module.exports = __webpack_public_path__ + "img/4.d75c575b.png";